// Sanitize a user-provided filename into a safe base name for display and download.
// Never interpret the input as HTML, URL, or path.
const ILLEGAL_RE = /[\\/<>|?:*"]/g
const CONTROL_RE = /[\x00-\x1f\x80-\x9f]/g // eslint-disable-line no-control-regex

const MAX_BASE_NAME_LENGTH = 200

export function safeBaseName(fileName: string): string {
  // Remove known file extensions, then replace control chars and illegal/path separators.
  let name = fileName.replace(/\.(heic|heif|jpg|jpeg|png|pdf)$/i, '')
  name = name.replace(CONTROL_RE, '_').replace(ILLEGAL_RE, '_').trim()
  if (name.length > MAX_BASE_NAME_LENGTH) {
    name = name.slice(0, MAX_BASE_NAME_LENGTH)
  }
  return name || 'heic-file'
}

export function downloadName(fileName: string, extension: string): string {
  const base = safeBaseName(fileName)
  const ext = extension.replace(/^\.+/, '')
  return `${base}.${ext}`
}
